import axios from 'axios'
// import QS from 'qs'
import urls from './urls'
import docCookies from '../assets/js/utile.js'
// import login from '../assets/js/utile.js'
// 跨域携带session
axios.defaults.withCredentials = false

const service = axios.create({
  baseURL: urls.baseSpma, // 向后台请求的接口地址的前缀
  timeout: 115000, // 请求的响应时间
})

// http request 请求拦截器，对请求数据处理，有token值则配置上token值
service.interceptors.request.use(
  config => {
    if(!config.headers['token']){
      // if(localStorage.getItem('userInfo')){
      //   config.headers['token'] = JSON.parse(localStorage.getItem('userInfo')).token;
      //   config.headers['userid'] = JSON.parse(localStorage.getItem('userInfo')).user_id;
      // }
	  // if(docCookies.getItem('token')){
		 //  config.headers['token'] = docCookies.getItem('token');
		 //  config.headers['userid'] = docCookies.getItem('user_id');
	  // }
    if(docCookies.getItem('unionid')){
      config.headers['token'] = docCookies.getItem('unionid');
    }
    }
    return config
  }, error => {
    console.log(error)
    return Promise.reject(error)
  })

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code == 200) {
      return Promise.resolve(res)
    } else if(res.code==666){
      // if(res.msg === '未登录'){
      //   login();
      // }
      return Promise.reject(res)
    }else{
      return Promise.reject(res)
    }
  },
  error => {
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utile/requestOther.js